import { v4 as uuid } from "uuid";
import {Model} from "./base/Model";
import {Collection} from "./base/Collection";
import { Worklog } from "./Worklog";
import moment from 'moment';


class DossierCompanyCPersonModel extends Model {
    key:string;
    name:string;
}

class DossierCompanyModel extends Model {
    key:string;
    name:string;
    cperson:DossierCompanyCPersonModel = new DossierCompanyCPersonModel();
}

    export class Dossier extends Model  {
        children: Collection = new Collection();
        start_date:number;
        delivery_date:number;
        customer:string;
        company:DossierCompanyModel = new DossierCompanyModel();
        total_workhours:number|null;
        worklog: Worklog = new Worklog();
         
        constructor(data = null) {
            super(data);
            if(data) {
                if(data["simple_children"]) {
                    this["children"] = new Collection(data["simple_children"], Dossier);
                    }
                if(data["children"]) {
                    this["children"] = new Collection(data["children"], Dossier);
                    }
                
                this.createModel(data, {children: Dossier});
                if(data["worklog"]) {
                    this.worklog = new Worklog(data["worklog"]);
                }
            }
            
//            if(data.worklog && data.worklog.logs && Array.isArray(this["worklog"]["logs"])) {
//                this["worklog"]["logs"] = new Collection(data.worklog.logs);
//            }
        }      

        public getStartDate() {
            let retVal;
            retVal = moment(this.start_date);
            return retVal; 
        }

        public setStartDate(val) {
            if(typeof val == 'object') {
                this.start_date = val.utc().startOf('day').valueOf();
            } else if(typeof val == 'number') {
                this.start_date = val;
            }
            return this.start_date; 
        }

        public getDeliveryDate() {
            let retVal;
            retVal = moment(this.delivery_date);
            return retVal; 
        }

        public setDeliveryDate(val) {
            this.delivery_date = val.utc().startOf('day').valueOf();;
            return this.delivery_date; 
        }
        
        public getKeyName() {
            let key = this['key'];
            let keyName = 'key';
            if(!key) {
                keyName = 'ref';
            }
            return keyName;
        }
        
        public getKey() {
            let key = this[this.getKeyName()];
            return key;
        }
        
        public getChildrenForState(keyName = "state", key) {
            let tasks = [];
                if(this.children instanceof Collection && this.children.length > 0) {
                    tasks = this.children.where(keyName, key).get();
                }
            return tasks;
            }
        
        public getTaskByKey(key, keyName = "ref") {
            let task = null;
            if(this[keyName] && this[keyName].trim() == key.trim()) {
                task = this;
            } else {
                if(this.children instanceof Collection && this.children.length > 0) {
                    task = this.children.findChildByKey(key, keyName);
                }
            }
            return task;
        }      
        
        public getDossierKeys() {
            let retVal = {dossier_key: null, dossiertask_key: null};
            
            if(!this['dossier_path']) {
                retVal['dossier_key'] = this['uid'];
            } else {
                let keys = this['dossier_path'].split('.');
                retVal['dossier_key'] = keys[0];
                retVal['dossiertask_key'] = this['uid'];
            }
            
            return retVal;
        }
        
        public hasDossierUid(val) {
            let retVal = false;
            retVal = val.includes(this.uid);
            return retVal;
        }
        
                      
    }